import { useIsProjectOwner } from './useIsProjectOwner';
import { useIsSubscriptionActive } from '../subscriptions/useIsSubscriptionActive';

/**
 * Hook to determine if the current user has edit permission for a project
 * Edit permission is granted to:
 * - Project owners (always)
 * - Collaborators with 'edit' role (only if subscription is active)
 * View-only collaborators never have edit permission
 *
 * @param {object} project - The project object
 * @returns {boolean} True if user can edit the project
 */
export function useHasEditPermission(project) {
  const isOwner = useIsProjectOwner(project);
  const isSubscriptionActive = useIsSubscriptionActive();

  // Owner always has permission
  if (isOwner) {
    return true;
  }

  // View-only never has permission
  if (project?.role === 'view_only') {
    return false;
  }

  // Edit collaborator needs active subscription
  if (project?.role === 'edit') {
    return isSubscriptionActive;
  }

  // No role and not owner = no permission
  return false;
}
